var r = {
  agentWorkspace: {
    s: {
      chat: {
        attachment: function attachment() {
          return import("./index.es234.js");
        },
        bold: function bold() {
          return import("./index.es235.js");
        },
        italic: function italic() {
          return import("./index.es236.js");
        },
        mic: function mic() {
          return import("./index.es237.js");
        },
        send: function send() {
          return import("./index.es238.js");
        },
        templates: function templates() {
          return import("./index.es239.js");
        },
        underline: function underline() {
          return import("./index.es240.js");
        }
      },
      supplementary: {
        archive: function archive() {
          return import("./index.es241.js");
        },
        audioFile: function audioFile() {
          return import("./index.es242.js");
        },
        doubleTick: function doubleTick() {
          return import("./index.es243.js");
        },
        imageFile: function imageFile() {
          return import("./index.es244.js");
        },
        singleTick: function singleTick() {
          return import("./index.es245.js");
        },
        videoFile: function videoFile() {
          return import("./index.es246.js");
        }
      }
    }
  },
  colored: {
    focusFacebook: function focusFacebook() {
      return import("./index.es247.js");
    },
    focusInstagram: function focusInstagram() {
      return import("./index.es248.js");
    },
    focusTelegram: function focusTelegram() {
      return import("./index.es249.js");
    },
    focusViber: function focusViber() {
      return import("./index.es250.js");
    },
    focusWebchat: function focusWebchat() {
      return import("./index.es251.js");
    },
    focusWhatsapp: function focusWhatsapp() {
      return import("./index.es252.js");
    },
    instagram: function instagram() {
      return import("./index.es253.js");
    }
  },
  filled: {
    dashboard: function dashboard() {
      return import("./index.es254.js");
    }
  },
  filled16: {
    star: function star() {
      return import("./index.es255.js");
    }
  },
  flowbuilder: {
    condition: function condition() {
      return import("./index.es256.js");
    },
    dtmf: function dtmf() {
      return import("./index.es257.js");
    },
    end: function end() {
      return import("./index.es258.js");
    },
    focus: function focus() {
      return import("./index.es259.js");
    },
    httpRequest: function httpRequest() {
      return import("./index.es260.js");
    },
    message: function message() {
      return import("./index.es261.js");
    },
    moreVertical: function moreVertical() {
      return import("./index.es262.js");
    },
    playAudio: function playAudio() {
      return import("./index.es263.js");
    },
    route: function route() {
      return import("./index.es264.js");
    },
    sendMessage: function sendMessage() {
      return import("./index.es265.js");
    },
    start: function start() {
      return import("./index.es266.js");
    },
    voicemail: function voicemail() {
      return import("./index.es267.js");
    }
  },
  inPageImage: {
    spinner: function spinner() {
      return import("./index.es268.js");
    },
    warningTriangle: function warningTriangle() {
      return import("./index.es269.js");
    }
  },
  logos: {
    americanExpressInvert: function americanExpressInvert() {
      return import("./index.es270.js");
    },
    americanExpress: function americanExpress() {
      return import("./index.es271.js");
    },
    interacInvert: function interacInvert() {
      return import("./index.es272.js");
    },
    interac: function interac() {
      return import("./index.es273.js");
    },
    jcbInvert: function jcbInvert() {
      return import("./index.es274.js");
    },
    jcb: function jcb() {
      return import("./index.es275.js");
    },
    paypal: function paypal() {
      return import("./index.es276.js");
    },
    pci: function pci() {
      return import("./index.es277.js");
    },
    unionPay: function unionPay() {
      return import("./index.es278.js");
    },
    visa: function visa() {
      return import("./index.es279.js");
    },
    voiso: function voiso() {
      return import("./index.es280.js");
    }
  },
  outline: {
    add: function add() {
      return import("./index.es281.js");
    },
    airplane: function airplane() {
      return import("./index.es282.js");
    },
    backArrowCircle: function backArrowCircle() {
      return import("./index.es283.js");
    },
    backArrow: function backArrow() {
      return import("./index.es284.js");
    },
    burger: function burger() {
      return import("./index.es285.js");
    },
    cat: function cat() {
      return import("./index.es286.js");
    },
    clock: function clock() {
      return import("./index.es287.js");
    },
    closeCircle: function closeCircle() {
      return import("./index.es288.js");
    },
    close: function close() {
      return import("./index.es289.js");
    },
    dotted: function dotted() {
      return import("./index.es290.js");
    },
    download: function download() {
      return import("./index.es291.js");
    },
    expandArrow: function expandArrow() {
      return import("./index.es292.js");
    },
    facebook: function facebook() {
      return import("./index.es293.js");
    },
    flag: function flag() {
      return import("./index.es294.js");
    },
    football: function football() {
      return import("./index.es295.js");
    },
    forwardArrow: function forwardArrow() {
      return import("./index.es296.js");
    },
    info: function info() {
      return import("./index.es297.js");
    },
    instagram: function instagram() {
      return import("./index.es298.js");
    },
    lamp: function lamp() {
      return import("./index.es299.js");
    },
    loading: function loading() {
      return import("./index.es300.js");
    },
    minusMath: function minusMath() {
      return import("./index.es301.js");
    },
    more: function more() {
      return import("./index.es302.js");
    },
    peace: function peace() {
      return import("./index.es303.js");
    },
    play: function play() {
      return import("./index.es304.js");
    },
    plusMath: function plusMath() {
      return import("./index.es305.js");
    },
    resize: function resize() {
      return import("./index.es306.js");
    },
    smile: function smile() {
      return import("./index.es307.js");
    },
    stop: function stop() {
      return import("./index.es308.js");
    },
    telegram: function telegram() {
      return import("./index.es309.js");
    },
    warning: function warning() {
      return import("./index.es310.js");
    },
    whatsApp: function whatsApp() {
      return import("./index.es311.js");
    }
  },
  softphone: {
    conference: function conference() {
      return import("./index.es312.js");
    },
    consultation: function consultation() {
      return import("./index.es313.js");
    },
    hand: function hand() {
      return import("./index.es314.js");
    },
    hangUp: function hangUp() {
      return import("./index.es315.js");
    },
    hold: function hold() {
      return import("./index.es316.js");
    },
    keypad: function keypad() {
      return import("./index.es317.js");
    },
    microphone: function microphone() {
      return import("./index.es318.js");
    },
    rec: function rec() {
      return import("./index.es319.js");
    },
    sms: function sms() {
      return import("./index.es320.js");
    },
    transfer: function transfer() {
      return import("./index.es321.js");
    }
  },
  system: {
    l: {
      player: {
        forward: function forward() {
          return import("./index.es322.js");
        },
        pause: function pause() {
          return import("./index.es323.js");
        },
        play: function play() {
          return import("./index.es324.js");
        },
        playbackSpeed10: function playbackSpeed10() {
          return import("./index.es325.js");
        },
        playbackSpeed15: function playbackSpeed15() {
          return import("./index.es326.js");
        },
        playbackSpeed20: function playbackSpeed20() {
          return import("./index.es327.js");
        },
        rewind: function rewind() {
          return import("./index.es328.js");
        }
      }
    },
    m: {
      billing: {
        americanExpress: function americanExpress() {
          return import("./index.es329.js");
        },
        cartesBancaires: function cartesBancaires() {
          return import("./index.es330.js");
        },
        creditCard: function creditCard() {
          return import("./index.es331.js");
        },
        creditCardDisabled: function creditCardDisabled() {
          return import("./index.es332.js");
        },
        discoverDinnersClub: function discoverDinnersClub() {
          return import("./index.es333.js");
        },
        expressCheckout: function expressCheckout() {
          return import("./index.es334.js");
        },
        expressCheckoutDisabled: function expressCheckoutDisabled() {
          return import("./index.es335.js");
        },
        interac: function interac() {
          return import("./index.es336.js");
        },
        jcb: function jcb() {
          return import("./index.es337.js");
        },
        mastercard: function mastercard() {
          return import("./index.es338.js");
        },
        paypal: function paypal() {
          return import("./index.es339.js");
        },
        paypalDisabled: function paypalDisabled() {
          return import("./index.es340.js");
        },
        unionpay: function unionpay() {
          return import("./index.es341.js");
        },
        visa: function visa() {
          return import("./index.es342.js");
        }
      },
      utilities: {
        clone: function clone() {
          return import("./index.es343.js");
        },
        cross: function cross() {
          return import("./index.es344.js");
        },
        hamburger: function hamburger() {
          return import("./index.es345.js");
        },
        newMessage: function newMessage() {
          return import("./index.es346.js");
        }
      }
    },
    s: {
      channels: {
        dialer: function dialer() {
          return import("./index.es347.js");
        },
        facebook: function facebook() {
          return import("./index.es348.js");
        },
        hlrLookup: function hlrLookup() {
          return import("./index.es349.js");
        },
        inbound: function inbound() {
          return import("./index.es350.js");
        },
        inbox: function inbox() {
          return import("./index.es351.js");
        },
        instagram: function instagram() {
          return import("./index.es352.js");
        },
        outbound: function outbound() {
          return import("./index.es353.js");
        },
        sms: function sms() {
          return import("./index.es354.js");
        },
        telegram: function telegram() {
          return import("./index.es355.js");
        },
        viber: function viber() {
          return import("./index.es356.js");
        },
        voice: function voice() {
          return import("./index.es357.js");
        },
        weChat: function weChat() {
          return import("./index.es358.js");
        },
        webChat: function webChat() {
          return import("./index.es359.js");
        },
        whatsApp: function whatsApp() {
          return import("./index.es360.js");
        }
      },
      stateIndicators: {
        error: function error() {
          return import("./index.es361.js");
        },
        information: function information() {
          return import("./index.es362.js");
        },
        speaker: function speaker() {
          return import("./index.es363.js");
        },
        success: function success() {
          return import("./index.es364.js");
        },
        warning: function warning() {
          return import("./index.es365.js");
        }
      },
      utilities: {
        addToCidGr: function addToCidGr() {
          return import("./index.es366.js");
        },
        addToFlowOrScript: function addToFlowOrScript() {
          return import("./index.es367.js");
        },
        add: function add() {
          return import("./index.es368.js");
        },
        allChannels: function allChannels() {
          return import("./index.es369.js");
        },
        calendar: function calendar() {
          return import("./index.es370.js");
        },
        chevronDown: function chevronDown() {
          return import("./index.es371.js");
        },
        chevronUp: function chevronUp() {
          return import("./index.es372.js");
        },
        clock: function clock() {
          return import("./index.es373.js");
        },
        clone: function clone() {
          return import("./index.es374.js");
        },
        cross: function cross() {
          return import("./index.es375.js");
        },
        downloadCsv: function downloadCsv() {
          return import("./index.es376.js");
        },
        download: function download() {
          return import("./index.es377.js");
        },
        drag: function drag() {
          return import("./index.es378.js");
        },
        edit: function edit() {
          return import("./index.es379.js");
        },
        externalLink: function externalLink() {
          return import("./index.es380.js");
        },
        eyeHide: function eyeHide() {
          return import("./index.es381.js");
        },
        eyeOpen: function eyeOpen() {
          return import("./index.es382.js");
        },
        file: function file() {
          return import("./index.es383.js");
        },
        headphones: function headphones() {
          return import("./index.es384.js");
        },
        help: function help() {
          return import("./index.es385.js");
        },
        hierarchy: function hierarchy() {
          return import("./index.es386.js");
        },
        importCsv: function importCsv() {
          return import("./index.es387.js");
        },
        kebab: function kebab() {
          return import("./index.es388.js");
        },
        loupe: function loupe() {
          return import("./index.es389.js");
        },
        marked: function marked() {
          return import("./index.es390.js");
        },
        reply: function reply() {
          return import("./index.es391.js");
        },
        restore: function restore() {
          return import("./index.es392.js");
        },
        settings: function settings() {
          return import("./index.es393.js");
        },
        signOut: function signOut() {
          return import("./index.es394.js");
        },
        sortingDefault: function sortingDefault() {
          return import("./index.es395.js");
        },
        sortingDown: function sortingDown() {
          return import("./index.es396.js");
        },
        sortingUp: function sortingUp() {
          return import("./index.es397.js");
        },
        star: function star() {
          return import("./index.es398.js");
        },
        starred: function starred() {
          return import("./index.es399.js");
        },
        tick: function tick() {
          return import("./index.es400.js");
        },
        timer: function timer() {
          return import("./index.es401.js");
        },
        trashBin: function trashBin() {
          return import("./index.es402.js");
        },
        upload: function upload() {
          return import("./index.es403.js");
        },
        variable: function variable() {
          return import("./index.es404.js");
        },
        volumeOff: function volumeOff() {
          return import("./index.es405.js");
        },
        volumeOn: function volumeOn() {
          return import("./index.es406.js");
        }
      }
    },
    xs: {
      glyphs: {
        cross: function cross() {
          return import("./index.es407.js");
        },
        dash: function dash() {
          return import("./index.es408.js");
        },
        pause: function pause() {
          return import("./index.es409.js");
        },
        play: function play() {
          return import("./index.es410.js");
        },
        stop: function stop() {
          return import("./index.es411.js");
        },
        tick: function tick() {
          return import("./index.es412.js");
        }
      }
    }
  }
};
export { r as icons };